import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import * as echarts from 'echarts';


export default /*#__PURE__*/_defineComponent({
  __name: 'pieChart',
  props: {
    option: Object,
},
  setup(__props) {

const pieChart = ref();

const props = __props

onMounted(() => {
    const chart = echarts.init(pieChart.value);
    chart.setOption(props.option);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pie-chart",
    ref_key: "pieChart",
    ref: pieChart
  }, null, 512))
}
}

})